import { Box, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../styles/home.css";

import clientsImg from "../assets/illustrations/clients.svg";
import documentsImg from "../assets/illustrations/documents.svg";
import adminImg from "../assets/illustrations/admin.svg";
import inboxImg from "../assets/illustrations/inbox.svg";
import { useSelector } from "react-redux";

const MODULES = [
  {
    title: "Customer Management",
    description: "Manage and organize Customer data.",
    image: clientsImg,
    route: "/clients",
    color: "sage",
    featureKey: "clients",
  },
  {
    title: "Workspace Management",
    description: "Upload, organize, and manage Work.",
    image: documentsImg,
    route: "/workspace",
    color: "stone",
    featureKey: "workspace",
  },
  {
    title: "Admin Controls",
    description: "Manage users, roles, and system settings.",
    image: adminImg,
    route: "/admin",
    color: "charcoal",
  },
  {
    title: "Inbox & Messaging",
    description: "Communicate with users inside the application.",
    image: inboxImg,
    route: "/inbox",
    color: "mist",
    featureKey: "inbox",
  },
];

export default function Home() {
  const navigate = useNavigate();

  const featureFlags = useSelector((state) => state.admin.featureFlags);

  return (
    <Box className="home-container">
      <Box className="home-hero">
        <Box className="hero-content">
          <Typography variant="h4" className="home-title">
            Welcome to <span className="hero-highlight">Pebs</span>
            <br />
            Command Intelligence
          </Typography>
          <Typography className="home-subtitle">
            Pick a module below to start orchestrating clients, workspaces, and
            conversations with ease.
          </Typography>
          
        </Box>

        <Box className="hero-panel">
          <Typography className="panel-title">Campaign Performance</Typography>
          <Box className="panel-metrics">
            <Box className="panel-metric">
              <Typography className="panel-metric-value">120</Typography>
              <Typography className="panel-metric-label">Customers</Typography>
              <Box className="panel-bar">
                <Box className="panel-bar-fill panel-bar-fill-1" />
              </Box>
            </Box>
            <Box className="panel-metric">
              <Typography className="panel-metric-value">32</Typography>
              <Typography className="panel-metric-label">Workspaces</Typography>
              <Box className="panel-bar">
                <Box className="panel-bar-fill panel-bar-fill-2" />
              </Box>
            </Box>
            <Box className="panel-metric">
              <Typography className="panel-metric-value">8</Typography>
              <Typography className="panel-metric-label">Active Users</Typography>
              <Box className="panel-bar">
                <Box className="panel-bar-fill panel-bar-fill-3" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {MODULES.filter((module) => {
          if (!module.featureKey) return true;
          return featureFlags?.[module.featureKey];
        }).map((module) => (
          <Grid item xs={12} md={6} key={module.title}>
            <Box className={`module-card ${module.color}`}>
              <img
                src={module.image}
                alt={module.title}
                className="module-image"
              />

              <Box className="module-content">
                <Typography variant="h6">{module.title}</Typography>

                <Typography className="module-description">
                  {module.description}
                </Typography>

                <Button
                  variant="contained"
                  className="module-button"
                  onClick={() => navigate(module.route)}
                >
                  Go to module →
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box className="activity-section">
        <Typography variant="h6" className="activity-title">
          Recent Activity
        </Typography>

        <Box className="activity-list">
          <Box className="activity-item">
            <span className="activity-dot sage" />
            <span>New user invited</span>
            <span className="activity-time">2 hours ago</span>
          </Box>

          <Box className="activity-item">
            <span className="activity-dot mist" />
            <span>Document uploaded</span>
            <span className="activity-time">1 day ago</span>
          </Box>

          <Box className="activity-item">
            <span className="activity-dot stone" />
            <span>Client added</span>
            <span className="activity-time">3 days ago</span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
